/**
 * Добавляется во все компоненты и страницы
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      baseUrl: window.location.origin + window.config.BaseUrl,
      statuseKeys: {
        REGISTRY: 1, // Реєстрація
        CLARIFICATION_PERIOD: 2, // Період уточнень
        BID_ANALYSIS: 3, // Аналіз пропозицій
        SUBMISSION: 4, // Прийом пропозицій
        PREQUALIFICATION: 5, // Прекваліфікація
        PREQUALIFICATION_APPEAL: 6, // Прекваліфікація (період оскарження)
        AUCTION: 7, // Аукціон
        QUALIFICATION: 8, // Кваліфікація
        PROPOSALS_CONSIDERED: 9, // Пропозиції розглянуті
        COMPLETED: 10, // Завершено
        PURCHASE_NOT_PLACED: 11, // Закупівля не відбулась
        CANCELED: 12, // Закупівля відмінена
        ACTIVE: 13, // Активна
        CONTRACT_INTENT_PUBLISHED: 14, // Опубліковано намір укласти договір
        AWAITING_ORGANIZER_DECISION: 15, // Очікування рішення організатора
        AWAITING_STAGE_2: 16, // Очікування стадії 2
        QUALIFICATION_WINNERS_APPEAL: 17, // Кваліфікація переможців (період оскарження)
        INVITATION_NOT_ACTIVATED: 18, // Неактивоване запрошення
        DRAFT_PUBLICATION: 19, // Чернетка (публікація)
      },
      developmentLogins: ['medvedev', 'medvedev@it.ua'], //Логины пользователей разработчиков. Есть служебные блоки, которые только им отображаются.
    }
  },
  methods: {
    /**
     * получаем хеш
     * @param {*} obj объект или массив
     * @returns
     */
    $_hashCode(obj) {
      const str = JSON.stringify(obj, (key, value) => {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          return Object.keys(value).sort().reduce((sortedObj, key) => {
            sortedObj[key] = value[key]
            return sortedObj
          }, {})
        }
        return value
      })

      let hash = 0x811c9dc5 // 32-битный FNV-1a prime
      const prime = 0x01000193 // 32-битный FNV-1a offset basis

      for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i)
        hash = (hash * prime) >>> 0
      }

      return hash.toString(16)
    },
    /**
     * Мягкий скрон эллемента вниз
     * @param {*} item эллемент
     * @param {*} duration плавность
     */
    $_smoothScroll(item, duration = 500) {
      const scrollHeight = item.scrollHeight
      const clientHeight = item.clientHeight
      const startPosition = item.scrollTop
      const endPosition = scrollHeight - clientHeight
      let startTime

      function animateScroll(timestamp) {
        if (!startTime) { startTime = timestamp }
        const elapsedTime = timestamp - startTime

        if (elapsedTime < duration) {
          item.scrollTop = easeInOutQuad(elapsedTime, startPosition, endPosition - startPosition, duration)
          requestAnimationFrame(animateScroll)
        } else {
          item.scrollTop = endPosition
        }
      }

      function easeInOutQuad(t, b, c, d) {
        t /= d / 2
        if (t < 1) { return c / 2 * t * t + b }
        t--
        return -c / 2 * (t * (t - 2) - 1) + b
      }

      requestAnimationFrame(animateScroll)
    }
  },
  computed: {
    ...mapGetters({
      growthBook: 'getGrowthBook',
      currentUser: 'GET_USER',
      storedCurrentOrganization: 'getCurrentOrganization',
    }),
    isDeveloper() {
      const currentLogin = (this.currentUser?.login || '').toLowerCase()
      return this.developmentLogins?.includes(currentLogin) && this.isNotProduction
    },
    isNotProduction() {
      return window.config?.node_env !== 'production'
    },
    isTesterOrgs() {
      if (!this.isNotProduction) {
        return false
      }
      const testerOrganisations = [112822, 269855]

      return testerOrganisations.includes(this.storedCurrentOrganization.organizationItId)
    }
  },
  beforeDestroy() {
    Object.keys(this.$options.computed).forEach((computedKey) => {
      this.$watch(computedKey, null)
    })
    this.$options.watch = {}
  },
}
